import React, { Component } from 'react'
import MaskedInputWrap from '.././maskedInputWrap.jsx'

const ConfirmPhone = props => {
    const translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]
    let {
        phoneCode,
        handlePhoneNumberChange,
        inputFocus,
        handleConfirmCodeComponent,
    } = props

    return (
        <div className="phone-number__code">
            <MaskedInputWrap
                type={'tfa_code'}
                styles={'phone-number__code-input'}
                value={phoneCode}
                changeValue={event => {
                    handlePhoneNumberChange(['phoneCode'], event)
                }}
                reference={ref => inputFocus(ref)}
                placeholderChar={'\u2000'}
                placeholder={`${translation['Enter the received code']}...`}
            />
            <button
                className="phone-number__button phone-number__button_check"
                onClick={handleConfirmCodeComponent}
            >
                {translation['Check']}
            </button>
        </div>
    )
}

export default ConfirmPhone
